import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=484202cc&"
import script from "./blank.vue?vue&type=script&lang=js&"
export * from "./blank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('484202cc')) {
      api.createRecord('484202cc', component.options)
    } else {
      api.reload('484202cc', component.options)
    }
    module.hot.accept("./blank.vue?vue&type=template&id=484202cc&", function () {
      api.rerender('484202cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/blank.vue"
export default component.exports